import  React from 'react'
import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import { TableData, TableBody, TableColumn } from './TableBody'
import { TableHeader } from './TableHeader'
import { TableImport, TableImportProps } from './TableImport'
import {
  ShowIf, IField, getRequiredError, ErrorText,
} from '../fields'
import { TableSectionProps } from './TableSection'
import { TableTotal } from './TableTotal'
import { ImportContext } from '../../models/ImportContext'

export interface TableProps<D extends TableData> {
    id: string
    label: string
    columns: TableColumn<D>[]
    value: D[]
    summaryRows?: D[]
    onChange?: { (value: D[]): any }
    renderSection?: { (p: TableSectionProps<D>, i: number): JSX.Element }
    total?: { (entries: D[]): any }

    importContext?: ImportContext
    importUrl?: string
    exportUrl?: string
    match?: { (a: D, b: D): boolean }
    batchSize?: number

    header?: JSX.Element
    preview?: boolean
    required?: boolean
    requiredMessage?: string
    errorMessage?: string
    visible?: boolean

    allowEdit?: boolean
    allowImport?: boolean
    alwaysShowAllRows?: boolean

    additionalTableClasses?: string

    maxRows?: number
    invalidRows?: boolean
}

export interface TableState {
    expandImport: boolean
    errorMessage: string
}

export class Table<D extends TableData> extends React.Component<TableProps<D>, TableState> implements IField {
    container: HTMLDivElement

    body: TableBody<D>

    constructor(props: TableProps<D>) {
      super(props)

      this.state = {
        expandImport: false,
        errorMessage: null,
      }
    }

    public saveAndClose(callback: { (res: boolean): any }) {
      this.body.saveAndClose(callback)
    }

    getErrorMessage(): string {
      if (this.props.required === true) {
        if (!this.props.value || this.props.value.length === 0) {
          return getRequiredError(this.props)
        }
      }
      return null
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
      const errorMessage = this.getErrorMessage()
      this.setError(errorMessage, () => {
        if (errorMessage || this.props.errorMessage) {
          if (focus === true) {
            this.focus()
          }
        }
        callback && callback(!((this.props.errorMessage || errorMessage)))
      })
    }

    setError(errorMessage?: string, callback?: { (): any }) {
      this.setState({ errorMessage }, callback)
    }

    focus() {
      const temp = this.container.getElementsByTagName('button')
      if (temp && temp.length > 0) {
        temp[0].focus()
      }
    }

    render() {
      return (
        <>
          <div
            ref={(r) => this.container = r}
            style={{ display: this.props.visible === false ? 'none' : '' }}
            className={`table-container ${this.props.additionalTableClasses}`
              + `${this.props.errorMessage || this.state.errorMessage ? ' table-container-invalid' : ''}`
              + `${this.props.visible === false ? ' form-hidden-preview' : ''}`}
          >
            <TableHeader label={this.props.label} preview={this.props.preview}>
              {this.props.header || (
              <>
                <Button className="emdg-btn" id="btnDeleteAll" onClick={(e) => this.body.deleteAll()}>Delete all</Button>
                {' '}
  &nbsp;
                <Button className="emdg-btn" id="btnImportSchedules" onClick={(e) => this.setState({ expandImport: true }, () => this.body.toggleNew(false))} style={{ display: this.props.allowImport ? '' : 'none' }}>Import/export data</Button>
                {' '}
  &nbsp;
                <Button className="emdg-btn" id="btnAddSchedule" onClick={(e) => this.setState({ expandImport: false }, () => this.body.toggleNew(true))} style={{ display: this.props.maxRows && this.props.maxRows <= this.props.value.length ? 'none' : '' }}>Add</Button>
              </>
              )}
            </TableHeader>
            <ShowIf className="form-section" condition={this.state.expandImport}>
              <TableImport
                {...this.props}
                importContext={this.props.importContext}
                id={`${this.props.id}-import`}
                onChange={this.props.onChange}
                renderSection={this.props.renderSection}
                importUrl={this.props.importUrl}
                exportUrl={this.props.exportUrl}
              />
              <div className="clearfix">
                <Button className="emdg-btn emdg-btn--secondary float-right mt-3" onClick={(e) => this.setState({ expandImport: false })}>Hide</Button>
              </div>
            </ShowIf>
            {this.props.invalidRows && (
            <div>
              <br />
              <Alert className="emdg-page-alerts emdg-page-alerts--error">
                <p>One or more rows contains validation or other errors. Please expand the row for more details and to amend.</p>
              </Alert>
              <br />
            </div>
            )}
            <TableBody<D> {...this.props} ref={(r) => this.body = r} id={`${this.props.id}-body`} />
            <TableTotal total={this.props.total && this.props.total(this.props.value)} />
          </div>
          <ErrorText text={this.props.errorMessage} />
        </>
      )
    }
}
